const Manager = [
	{
		title: '主页',
		key: 'Home',
		icon: 'h-icon-home'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'h-icon-star',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			},
		{
			title: '凭证汇总表',
			key: 'SubjectSummary'
		},
			{
				title: '业务凭证',
				key: 'Tripartite',
			},
			{
				title: '企业税申报',
				key: 'Declare'
			}
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'h-icon-task',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '多栏账',
				key: 'MultiColumnLedger'
			},
			{
				title: '账龄分析表',
				key: 'AgeAnalysis'
			}
		]
	},
	{
		title: '报表',
		key: 'Report',
		icon: 'h-icon-search',
		children: [
			{ title: '报表', key: 'ReportList' },
			{ title: '自定义报表', key: 'BiReportList' },
			{ title: '费用明细表', key: 'ExpenseDetailReport' },
			{ title: '资产负债表月报', key: 'BalanceStatement' },
			{ title: '利润表月报', key: 'ProfitStatement' },
			{ title: '现金流量表月报', key: 'CashFlowStatement' },
			{ title: '利润表季报', key: 'ProfitStatementQuarter' },
			{ title: '现金流量表季报', key: 'CashFlowStatementQuarter' },
			{ title: '业务活动表', key: 'BusinessActivityStatement' },
			{ title: '业务活动表季报', key: 'BusinessActivityStatementQuarter' }
		]
	},
	{
		title: '结账',
		key: 'CheckList',
		icon: 'h-icon-complete',
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'h-icon-setting',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '期初',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			}, {
				title: '辅助核算',
				key: 'AccountingCategory'
			}/*, {
				title: '凭证模板',
				key: 'TemplateManager'
			}*/, 			{
				title: '权限设置',
				key: 'PermissionSetting'
			}

		,
			{ title: '旧账同步', key: 'SyncIndex' },
				{ title: '备份恢复', key: 'BackupIndex' },
				{ title: '审计数据', key: 'AuditExportIndex' },
				{ title: '审计日志', key: 'AuditLogIndex' }]
	}
];

const Making = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			},
		{
			title: '凭证汇总表',
			key: 'SubjectSummary'
		},
			{
				title: '业务凭证',
				key: 'Tripartite',
			},
			{
				title: '企业税申报',
				key: 'Declare'
			}
		]
	},
	{
		title: '结账',
		key: 'CheckList',
		icon: 'icon-disc',
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '多栏账',
				key: 'MultiColumnLedger'
			},
			{
				title: '账龄分析表',
				key: 'AgeAnalysis'
			}
		]
	},
	{
		title: '报表',
		key: 'Report',
		icon: 'icon-bar-graph-2',
		children: [
			{ title: '报表', key: 'ReportList' },
			{ title: '自定义报表', key: 'BiReportList' },
			{ title: '费用明细表', key: 'ExpenseDetailReport' },
			{ title: '资产负债表月报', key: 'BalanceStatement' },
			{ title: '利润表月报', key: 'ProfitStatement' },
			{ title: '现金流量表月报', key: 'CashFlowStatement' },
			{ title: '利润表季报', key: 'ProfitStatementQuarter' },
			{ title: '现金流量表季报', key: 'CashFlowStatementQuarter' },
			{ title: '业务活动表', key: 'BusinessActivityStatement' },
			{ title: '业务活动表季报', key: 'BusinessActivityStatementQuarter' }
		]
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		,
			{ title: '旧账同步', key: 'SyncIndex' },
				{ title: '备份恢复', key: 'BackupIndex' },
				{ title: '审计数据', key: 'AuditExportIndex' },
				{ title: '审计日志', key: 'AuditLogIndex' }]
	}
];

const View = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '凭证列表',
				key: 'Voucher'
			},
		{
			title: '凭证汇总表',
			key: 'SubjectSummary'
		},
			{
				title: '业务凭证',
				key: 'Tripartite',
			},
			{
				title: '企业税申报',
				key: 'Declare'
			}
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '序时账',
				key: 'TimeSeries'
			},
			{
				title: '多栏账',
				key: 'MultiColumnLedger'
			},
			{
				title: '账龄分析表',
				key: 'AgeAnalysis'
			}
		]
	},
	{
		title: '报表',
		key: 'Report',
		icon: 'icon-bar-graph-2',
		children: [
			{ title: '报表', key: 'ReportList' },
			{ title: '自定义报表', key: 'BiReportList' },
			{ title: '费用明细表', key: 'ExpenseDetailReport' },
			{ title: '资产负债表月报', key: 'BalanceStatement' },
			{ title: '利润表月报', key: 'ProfitStatement' },
			{ title: '现金流量表月报', key: 'CashFlowStatement' },
			{ title: '利润表季报', key: 'ProfitStatementQuarter' },
			{ title: '现金流量表季报', key: 'CashFlowStatementQuarter' },
			{ title: '业务活动表', key: 'BusinessActivityStatement' },
			{ title: '业务活动表季报', key: 'BusinessActivityStatementQuarter' }
		,
			{ title: '旧账同步', key: 'SyncIndex' },
				{ title: '备份恢复', key: 'BackupIndex' },
				{ title: '审计数据', key: 'AuditExportIndex' },
				{ title: '审计日志', key: 'AuditLogIndex' }]
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		]
	}
];

const AssetsMenu = {
	title: '资产',
	key: 'Assets',
	icon: 'icon-box',
	children: [
		{ title: '资产管理', key: 'Assets' },
		{ title: '资产类别', key: 'AssetsType' },
		{ title: '折旧明细表', key: 'AssetsDepreciation' },
		{ title: '资产汇总', key: 'AssetsSummary' },
		{ title: '资产对账', key: 'AssetsCheck' }
	]
};
Manager.push(AssetsMenu);
Making.push(AssetsMenu);
View.push(AssetsMenu);

const FundsMenu = {
	title: '资金',
	key: 'Cashier',
	icon: 'icon-briefcase',
	children: [
		{ title: '日记账', key: 'CashierJournal' },
		{ title: '内部转账', key: 'CashierTransfer' },
		{ title: '资金报表', key: 'CashierReport' },
		{ title: '核对总账', key: 'CashierCheck' },
		{ title: '收支类别', key: 'CashierIoType' },
		{ title: '账户设置', key: 'CashierAccount' }
	]
};
Manager.push(FundsMenu);
Making.push(FundsMenu);
View.push(FundsMenu);

const InvoiceMenu = {
	title: '发票',
	key: 'Invoice',
	icon: 'icon-file',
	children: [
		{ title: '销项发票', key: 'OutputInvoice' },
		{ title: '进项发票', key: 'IncomeInvoice' },
		{ title: '费用单据', key: 'Expense' },
		{ title: '无票收入', key: 'NonIncome' },
		{ title: '智能开票', key: 'IntelligentInvoicing' }
	]
};
Manager.push(InvoiceMenu);
Making.push(InvoiceMenu);
View.push(InvoiceMenu);

const SalaryMenu = {
	title: '工资',
	key: 'Salary',
	icon: 'icon-coin',
	children: [
		{ title: '工资信息', key: 'SalaryInfo' },
		{ title: '员工信息', key: 'SalaryEmployee' },
		{ title: '五险一金设置', key: 'SalaryInsurance' },
		{ title: '个税申报', key: 'SalaryTaxDeclare' }
	]
};
Manager.push(SalaryMenu);
Making.push(SalaryMenu);
View.push(SalaryMenu);

export default {
	Manager,
	Making,
	View
};
